import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";

import { ViewChild, TemplateRef } from "@angular/core";
import { ToastService } from "ng-uikit-pro-standard";
import { MatDialog } from "@angular/material";
import { DataService } from "./../../data.service";
import { GUID } from "./../../guid";
import { AppConfig } from "./../../config";
@Component({
  selector: "app-reporttypelayout",
  templateUrl: "./reporttypelayout.component.html",
  styleUrls: ["./reporttypelayout.component.scss"],
})
export class ReporttypelayoutComponent implements OnInit {
  @ViewChild("myCityDialog", { static: false }) cityDialog!: TemplateRef<any>;

  draggedIndex: number | null = null;
  showDialogContainer: boolean = false;
  data: any = {};

  changedFields = [];

  isLoading = false;
  isError = false;
  errorMessage = "";
  mode = "";
  reportTypeId = "";
  reporttypesection = [];
  reporttypecolumn = [];
  reportsectionId = "";
  gridData: any[] = [];
  selectedFieldName: any | null = null;
  selectedFieldNameMap: { [sectionName: string]: any } = {};
  dialogRef: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private toastrService: ToastService,
    private appConfig: AppConfig,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.reportTypeId = this.route.snapshot.params.id;
      // this.objectName = this.route.snapshot.params.objectname;
    });

    // this.getReportTypeSectionById().then((res) => {
    //   console.log("response222222", res);
    //   // this.getReportTypeColumnById();

    // });

    this.getReportTypeSectionById().then(async () => {
      await this.getReportTypeColumnById();
      const gridData = [];
      console.log("ReportTypeSection:", this.reporttypesection);
      console.log("ReportTypeColumn:", this.reporttypecolumn);
      for (const section of this.reporttypesection) {
        const sectionId = section.id;
        const sectionName = section.sectionname;
        const matchingColumns = this.reporttypecolumn.filter(
          (column) => column.reporttypesectionid === sectionId
        );
        const fieldnames = matchingColumns.map((column) => ({
          name: column.displaynameoverride,
          checked: column.checkedbydefault,
          fieldid: column.fieldid,
        }));
        gridData.push({ sectionId, sectionName, fieldnames });
      }
      console.log("Grid Data:", gridData);
      this.gridData = gridData; // Assigning gridData to the component property
    });

    // this.gridData.forEach((sectionData, index) => {
    //   sectionData.sectionId = index;
    // });
  }

  // selectFieldName(fieldName: string): void {
  //   this.selectedFieldName = fieldName;
  //   console.log("selected name", this.selectedFieldName)
  // }
  // selectFieldName(field: any): void {
  //   this.selectedFieldNameMap[field.sectionName] = field;
  //   console.log("field", field);
  // }
  // isSelected(sectionName: string, fieldName: string): boolean {
  //   const selectedField = this.selectedFieldNameMap[sectionName];
  //   return selectedField && selectedField.name === fieldName;
  // }

  isSelected(sectionName: string, fieldName: string): boolean {
    return this.selectedFieldNameMap[sectionName] === fieldName;
  }

  // drop(event: CdkDragDrop<string[]>) {
  //   moveItemInArray(this.gridData[event.previousContainer.id].fieldnames, event.previousIndex, event.currentIndex);
  // }

  // onFieldDropchange(event: DragEvent, newIndex: number) {
  //   event.preventDefault();

  //   console.log("Current index", this.draggedIndex);

  //   console.log("Dropped index", newIndex);
  //   if (this.draggedIndex !== null && this.draggedIndex !== newIndex) {
  //     // Swap the positions of the dragged item and the dropped item
  //     const tempField = this.gridData[this.draggedIndex].fieldnames[0];
  //     this.gridData[this.draggedIndex].fieldnames[0] = this.gridData[newIndex].fieldnames[0];
  //     this.gridData[newIndex].fieldnames[0] = tempField;

  //     console.log("Dropped data reordered:", this.gridData);
  //   }
  //   //Reset index
  //   this.draggedIndex = null;
  // }

  onFieldDropchange(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      console.log("event.previousContainer", event.previousContainer.id);
      console.log("event.container", event.container.id);
      console.log("event.previousIndex", event.previousIndex);

      //prevent dragging the name field
      var fld = event.previousContainer.data[event.previousIndex];
      // if (fld["fieldname"] == "name") return;

      if (this.gridData[0].fieldnames) {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragStart(event: DragEvent, index: number) {
    this.draggedIndex = index;
    // console.log("Current index",event);

    console.log(index);
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  // async loadData() {
  //   await this.getReportTypeSectionById();
  //   await this.getReportTypeColumnById();
  //   console.log("ReportTypeSection:", this.reporttypesection);
  //   console.log("ReportTypeColumn:", this.reporttypecolumn);
  //   // Component Logic
  //   const gridData = [];
  //   for (const section of this.reporttypesection) {
  //     console.log(this.reporttypesection);
  //     const sectionId = section.id;
  //     const matchingColumns = this.reporttypecolumn.filter(
  //       (column) => column.reporttypesectionid === sectionId
  //     );
  //     const objectNames = matchingColumns.map((column) => column.objectname);
  //     gridData.push({ sectionId, objectNames });
  //   }
  // }
  // edit() {
  //   this.dialogRef = this.dialog.open(this.cityDialog, {
  //     data: this.data, // Pass data to the dialog, or pass an empty object if not required
  //   });

  //   this.dialogRef.afterClosed().subscribe((result: any) => {
  //     console.log("The City dialog was closed.");
  //     // console.log(result?.name + " - " + result?.city);
  //   });
  // }
  // openDialog(field: any): void {
  //   console.log(field);
  //   // Initialize data object with field name and checked value
  //   this.data = {
  //     name: field.name,
  //     checkedbydefault: field.checked,
  //   };

  //   // Open the dialog with the initialized data
  //   this.dialogRef = this.dialog.open(this.cityDialog, {
  //     data: this.data,
  //     height: "300px",
  //     width: "400px",
  //   });

  //   this.dialogRef.afterClosed().subscribe((result: any) => {
  //     console.log("The City dialog was closed.");
  //     // console.log(result?.name + ' - ' + result?.checkedbydefault);
  //   });
  // }

  openDialog(field: any): void {
    if (!field) {
      return; // Do not open dialog if no field is selected
    }

    // Initialize data object with field name and checked value
    this.data = {
      name: field.name,
      checkedbydefault: field.checked,
      fieldid: field.fieldid,
    };

    // Open the dialog with the initialized data
    this.dialogRef = this.dialog.open(this.cityDialog, {
      data: this.data,
      height: "300px",
      width: "400px",
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The City dialog was closed.");
      if (result) {
        // Update the name of the selected field in the grid data
        this.selectedFieldNameMap[field.sectionName] = field;
      }
    });
  }

  selectFieldName(field: any): void {
    this.selectedFieldNameMap[field.sectionName] = field;
    console.log("field", field);
  }
  ok(): void {
    this.dialogRef.close(this.data);
    console.log(this.data);

    // this.changedFields.push(this.data)
    const existingItemIndex = this.changedFields.findIndex(
      (item) => item.fieldid === this.data.fieldid
    );
    if (existingItemIndex !== -1) {
      this.changedFields[existingItemIndex] = this.data;
    } else {
      this.changedFields.push(this.data);
    }
    console.log(this.changedFields);
    this.gridData.forEach((section) => {
      section.fieldnames.forEach((tile) => {
        if (tile.fieldid === this.data.fieldid) {
          console.log("hjdsh");
          tile.name = this.data.name;
          tile.checkedbydefault = this.data.checkedbydefault; // Update the checkedbydefault property
        }
      });
    });
  }

  getReportTypeSectionById() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          reporttypesection: {
            reporttypeid: this.reportTypeId,
          },
        },
      };
      console.log(this.reportTypeId);
      this.isLoading = true;
      this.dataService.getReportTypeSectionById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.reporttypesection = res.data.reporttypesection;
            // const report = res.data.reporttype;

            // this.detailForm.controls["name"].setValue(this.reporttype.)

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("no data");
            this.isLoading = false;
            resolve(null);

            //this.resetDetailFormControls();
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);

          //this.resetDetailFormControls();
        }
      );
    });
  }

  getReportTypeColumnById() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          reporttypecolumn: {
            reporttypeid: this.reportTypeId,
          },
        },
      };
      this.isLoading = true;
      console.log(postOption);
      this.dataService.getReportTypeColumnById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.reporttypecolumn = res.data.reporttypecolumn;
            // const report = res.data.reporttype;

            // this.detailForm.controls["name"].setValue(this.reporttype.)

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("no data");
            this.isLoading = false;
            //this.resetDetailFormControls();
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);

          //this.resetDetailFormControls();
        }
      );
    });
  }

  save() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
      subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        reporttype: {
          mode: this.mode,
          reporttypeid: this.reportTypeId,
          reporttypecolumn: this.changedFields,
        },
      },
    };

    console.log("postOption", postOption);

    console.log(postOption);

    this.isLoading = true;
    if (this.changedFields.length > 0) {
      this.dataService.upsertReportType(postOption).subscribe(
        (res) => {
          //alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.showSuccess(res.message);
            this.isLoading = false;
            this.router.navigateByUrl("/home/reporttypes");
          } else {
            console.log("error while saving");
            this.showError(res.message);
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.showError(err.message);
          this.isError = true;
          this.isLoading = false;
        }
      );
    } else {
      alert("Atleast change one field to save");
    }
  }
}
